export default __webpack_public_path__ + "static/media/qrCode.72fe445b.svg";